/**
 * Created by nijin on 1/12/16.
 */
import {Component} from "@angular/core";
@Component({
  selector: 'nuc-404',
  template: `
    <article class="template animated slideInRight">
      <h4>Inconceivable!</h4>
      <div>I do not think this page is where you think it is.</div>
    </article>
  `
})

export  class NotFoundComponent {

}




// WEBPACK FOOTER //
// ./src/app/404.component.ts